import {HomeCard} from './HomeCard';
import Admin from '../../../assets/images/admin.jpg';
import {LearnerPortalPrimaryColor} from '../../../theme/ThemeLearnerPortalPalette';
import {routes} from '../../common/constants/routes';

export default function HomeAdminPortalCard(): JSX.Element {
  return (
    <HomeCard
      cover={Admin}
      smallCoverUrl={Admin}
      title="Admin Portal"
      background={LearnerPortalPrimaryColor.light}
      path={routes.adminPortal.get()}
    />
  );
}
